import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { diagnosticActions } from '../../store/diagnostic/diagnosticSlice';
import * as diagnosticSlice from '../../store/diagnostic/diagnosticSlice';

export const useDiagnosticTest = () => {
    const dispatch = useAppDispatch();
    return {
        setReadingScore: useCallback((payload) => {
            dispatch(diagnosticActions.setReadingScore(payload));
        }, [dispatch]),

        readingScore: useAppSelector(diagnosticSlice.getReadingScore)
    }
}